import { nameofWWCCRequestSchemaWWCC, WWCCRequestView } from "../../firestore/Types/RequestSchema";
import { Textbox } from "../Common/Textbox";

export function WWCCRequest({ request }: { request: WWCCRequestView }) {
    return (
        <div className="section-box p-4">
            <div className="flex flex-row">
                <h3 className="section-title">WWCC Request:</h3>
            </div>
            <Textbox label={"WWCC number:"} name={nameofWWCCRequestSchemaWWCC} defaultValue={request.WWCC} isReadonly={true}></Textbox>
        </div>
    );
}